export interface StreamSettings {
  name?: string;
  deviceId?: string;
  bitrate?: number;
  sampleRate?: number;
  width?: number;
  height?: number;
  frameRate?: number;
  echoCancellation?: boolean;
  noiseSuppression?: boolean;
  autoGainControl?: boolean;
  channelCount?: number;
}
export const getDevices = async () => {
  const mediaDevice = navigator.mediaDevices;

  if (mediaDevice?.enumerateDevices) {
    return await mediaDevice.enumerateDevices();
  }
  throw new Error("Enumerate devices not supported");
};

export const getDeviceStream = async (
  device: MediaDeviceInfo,
  captureAudio = true,
  captureVideo = true,
  audioSettings?: StreamSettings,
  videoSettings?: StreamSettings,
): Promise<MediaStream> => {
  const { deviceId } = device;

  const audioConstraints = captureAudio
    ? {
        deviceId,
        ...(audioSettings?.sampleRate && {
          sampleRate: audioSettings.sampleRate,
        }),
        // Booleanos por presencia (no truthiness): un `false` explícito
        // (p.ej. apagar echoCancellation desde el modal) debe llegar a gUM.
        ...(audioSettings?.echoCancellation !== undefined && {
          echoCancellation: audioSettings.echoCancellation,
        }),
        ...(audioSettings?.noiseSuppression !== undefined && {
          noiseSuppression: audioSettings.noiseSuppression,
        }),
        ...(audioSettings?.autoGainControl !== undefined && {
          autoGainControl: audioSettings.autoGainControl,
        }),
        ...(audioSettings?.channelCount && {
          channelCount: audioSettings.channelCount,
        }),
      }
    : false;

  const videoConstraints = captureVideo
    ? {
        deviceId,
        ...(videoSettings?.width && { width: videoSettings.width }),
        ...(videoSettings?.height && { height: videoSettings.height }),
      }
    : false;

  return await navigator.mediaDevices.getUserMedia({
    audio: audioConstraints,
    video: videoConstraints,
  });
};
